export enum StorageKeys {
  supportToken = 'support_token',
}
